var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6014_12855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4713 4.862L19.5287 5.80467L29.0573 15.3333H4V16.6667H29.0573L19.5287 26.1953L20.4713 27.138L31.6093 16L20.4713 4.862Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 32H8.66667V30.6667H5.33333C3.12733 30.6667 1.33333 28.8727 1.33333 26.6667V5.33333C1.33333 3.12733 3.12733 1.33333 5.33333 1.33333H8.66667V0H5.33333C2.39267 0 0 2.39267 0 5.33333V26.6667C0 29.6073 2.39267 32 5.33333 32Z",
    fill: "#031434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6014_12855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMenuIcon);
export default __webpack_public_path__ + "static/media/logout_menu_icon.a84536538e2b4aad725cedc5b1a18fc4.svg";
export { ForwardRef as ReactComponent };